import { useCallback } from "react";
import { metricsBus } from "@/common/buses";

interface IProps {
  onClose?: () => void;
}

export const useQuickRecs = ({ onClose }: IProps) => {
  const handleClose = useCallback(() => {
    onClose && onClose();
  }, []);

  const getHandleClick = useCallback((position: number) => () => {
    metricsBus.emit("quickRecsItemClicked", { position });
  }, []);

  return {
    handleClose,
    getHandleClick,
  };
};
